// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bioDescriptionWrap {
	margin: 0;
	position: relative;
	isolation: isolate;
}

.bioDescriptionText {
	margin: 0;
	width: 100%;
	max-width: none;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	line-clamp: 3;
	line-height: var(--line-height-base, 1.5);
	position: relative;
	overflow: hidden;
}

.bioDescriptionText:not(.isExpanded)::after {
	content: '';
	position: absolute;
	right: 0;
	top: calc(100% - 1.5em);
	width: 50%;
	height: 1.5em;
	background: var(--color-card-bg);
	pointer-events: none;
}

.bioDescriptionText.isExpanded {
	display: block;
	-webkit-line-clamp: unset;
	line-clamp: unset;
	overflow: visible;
}

.bioDescriptionToggle {
	margin: 0;
	padding: 0;
	border: 0;
	background: none;
	color: var(--color-primary);
	cursor: pointer;
	font: inherit;
	font-size: var(--font-size-sm);
	line-height: var(--line-height-base, 1.5);
	position: absolute;
	left: 50%;
	bottom: 0;
	background-color: var(--color-card-bg);
	white-space: nowrap;
	min-height: auto;
	min-width: auto;
	padding-left: 0;
	padding-right: 0;
	padding-top: 0;
	padding-bottom: 0;
	margin-left: 0;
	margin-right: 0;
	z-index: 0;
}

.bioDescriptionWrap .bioDescriptionText:not(.isExpanded) + .bioDescriptionToggle {
	top: calc(100% - 1.5em + 0.28em - 12px);
	bottom: auto;
	transform: translateY(7px);
}

.bioDescriptionText.isExpanded + .bioDescriptionToggle {
	position: static;
	display: inline;
	padding-left: 0;
	top: auto;
	bottom: auto;
	transform: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/BioSection.css"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,WAAW;CACX,eAAe;CACf,oBAAoB;CACpB,4BAA4B;CAC5B,qBAAqB;CACrB,aAAa;CACb,yCAAyC;CACzC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,uBAAuB;CACvB,UAAU;CACV,aAAa;CACb,gCAAgC;CAChC,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,SAAS;CACT,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB,2BAA2B;CAC3B,eAAe;CACf,aAAa;CACb,8BAA8B;CAC9B,yCAAyC;CACzC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,sCAAsC;CACtC,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,YAAY;CACZ,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,eAAe;CACf,SAAS;CACT,YAAY;CACZ,eAAe;AAChB","sourcesContent":[".bioDescriptionWrap {\n\tmargin: 0;\n\tposition: relative;\n\tisolation: isolate;\n}\n\n.bioDescriptionText {\n\tmargin: 0;\n\twidth: 100%;\n\tmax-width: none;\n\tdisplay: -webkit-box;\n\t-webkit-box-orient: vertical;\n\t-webkit-line-clamp: 3;\n\tline-clamp: 3;\n\tline-height: var(--line-height-base, 1.5);\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.bioDescriptionText:not(.isExpanded)::after {\n\tcontent: '';\n\tposition: absolute;\n\tright: 0;\n\ttop: calc(100% - 1.5em);\n\twidth: 50%;\n\theight: 1.5em;\n\tbackground: var(--color-card-bg);\n\tpointer-events: none;\n}\n\n.bioDescriptionText.isExpanded {\n\tdisplay: block;\n\t-webkit-line-clamp: unset;\n\tline-clamp: unset;\n\toverflow: visible;\n}\n\n.bioDescriptionToggle {\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: none;\n\tcolor: var(--color-primary);\n\tcursor: pointer;\n\tfont: inherit;\n\tfont-size: var(--font-size-sm);\n\tline-height: var(--line-height-base, 1.5);\n\tposition: absolute;\n\tleft: 50%;\n\tbottom: 0;\n\tbackground-color: var(--color-card-bg);\n\twhite-space: nowrap;\n\tmin-height: auto;\n\tmin-width: auto;\n\tpadding-left: 0;\n\tpadding-right: 0;\n\tpadding-top: 0;\n\tpadding-bottom: 0;\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tz-index: 0;\n}\n\n.bioDescriptionWrap .bioDescriptionText:not(.isExpanded) + .bioDescriptionToggle {\n\ttop: calc(100% - 1.5em + 0.28em - 12px);\n\tbottom: auto;\n\ttransform: translateY(7px);\n}\n\n.bioDescriptionText.isExpanded + .bioDescriptionToggle {\n\tposition: static;\n\tdisplay: inline;\n\tpadding-left: 0;\n\ttop: auto;\n\tbottom: auto;\n\ttransform: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
